<script>
import { Menu } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        items: []
      },
      redirectRoute: null
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Formset({
          modelPath: [this, 'form', 'items'],
          items: this.form.items.map((item, i) => {
            return {
              headerLabel: get(item, ['link', 'label_pl']),
              fields: [
                new fields.Link({
                  label: 'Link',
                  modelPath: [this, 'form', 'items', i, 'link']
                })
              ]
            }
          })
        })
      ]
    }
  },
  computed: {
    service() {
      return Menu
    }
  }
}
</script>
